import { EngineProvider } from "../EngineProvider.js";
import type { GameSettings } from "../../model/GameSettings.js";
import { SimplePieceProvider } from "./SimplePieceProvider.js";
import { SimplePlayerStateProvider } from "./SimplePlayerStateProvider.js";
import { SimpleEngine } from "./SimpleEngine.js";
import type { PieceProvider } from "../PieceProvider.js";
import type { PlayerStateProvider } from "../PlayerStateProvider.js";

/**
 * A provider that creates simple rule sets.
 */
export class SimpleEngineProvider extends EngineProvider {

    createPieceProvider(
        _settings: GameSettings,
    ): PieceProvider {
        return new SimplePieceProvider();
    }

    createPlayerStateProvider(
        settings: GameSettings,
    ): PlayerStateProvider {
        return new SimplePlayerStateProvider(
            settings.getStartingPieceCount(),
        );
    }

    create(
        settings: GameSettings,
    ): SimpleEngine {
        return new SimpleEngine(
            settings,
            this.createPieceProvider(settings),
            this.createPlayerStateProvider(settings),
        );
    }
}
